import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getIntegrations = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/integrations`);
    return response.data;
  } catch (error) {
    console.error('Error fetching integrations:', error.response?.data || error);
    throw error;
  }
};
